














































































































































































import SecurityCodeForm from '@spa/components/organisms/payment/creditcard/SecurityCodeForm.vue'
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'

import { SelectOption } from '@/models/api/payment/parameter/type/user-select'
import { Payment } from '@/models/api/payment/payment'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ErrorBag } from '@/services/payment/options-validator'
import PaymentEditViewModel from '@spa/components/organisms/order/edit/payment/model/payment-edit-view-model'
import PaymentSelect from '@spa/components/organisms/order/edit/payment/PaymentSelect.vue'
import HighLightCreditCardPayment from '@spa/components/organisms/order/HighLightCreditCardPayment.vue'
import Creditcard from '@spa/components/organisms/payment/creditcard/Creditcard.vue'
import { CommercePurchaseMenu } from '@spa/services/api/purchase'
import { uniq } from 'lodash'

@Component({
  components: {
    Creditcard,
    HighLightCreditCardPayment,
    PaymentSelect,
    SecurityCodeForm,
  },
})
export default class PaymentEdit extends Vue {
  @Prop({ required: true })
  vm: PaymentEditViewModel

  /**
   * NOTE: 再注文時だけ使われる
   * TODO: 美ラボ・ホテラバリリース後すぐにリファクタリングしてこのプロパティを削除する
   * @see: https://github.com/my-color/front/issues/5077
   */
  @Prop({ required: false })
  deliveryMethod: string

  securityCode: string = ''

  @Prop({ required: true })
  validation: ErrorBag

  @Prop({ required: true })
  brandEnglishName: string | null

  /**
   * NOTE: 再注文時だけ代引き選択に関する注意文言を表示するために使う
   * @see: https://github.com/my-color/front/issues/5077
   */
  @Prop({ required: false, default: null })
  commercePurchaseMenu: CommercePurchaseMenu | null

  get noteAboutPaymentOnReorder(): string | null {
    if (this.commercePurchaseMenu === null) {
      return null
    }

    const deliveryMethods = uniq(this.commercePurchaseMenu.deliveryMethod.methods.reduce(
      (prev, method) => {
        switch (method.arrival_kind) {
          case 'posting':
            return [...prev, '「ポスト投函」']
          case 'unattended-delivery':
            return [...prev, '「置き配」']
          default:
            return prev
        }
      },
      [] as string[]
    ))

    return `※ 配送方法が${deliveryMethods.join('')}の場合、「代金引換」はご利用いただけません。`
  }

  get behaviorConfig(): BehaviorConfig {
    return BehaviorConfig.forHost
  }

  get highlightCreditCardPayment(): boolean {
    return this.behaviorConfig.orderConfirm.payment.highlightCreditCard
  }

  onSelect(payment: Payment) {
    if (!this.vm.availablePaymentList.isAvailablePayment(payment.id)) {
      this.onError('このお支払い方法はご利用いただけません。')

      return
    }

    this.$emit('select', payment)
  }

  onSubmit() {
    this.$emit('submit')
  }

  onCancel() {
    this.$emit('cancel')
  }

  onError(message: string) {
    this.$emit('error', message)
  }

  @Emit('option-select')
  onOptionSelected(_option: SelectOption) {
    // nothing
  }

  @Watch('securityCode')
  onUpdateCreditcardSecurityCode() {
    this.$emit('updateCreditcardSecurityCode', this.securityCode)
  }
}
